export default __webpack_public_path__ + "static/media/element_31.edcb2db5.avif";